import React from 'react';

import Img from 'gatsby-image';

import map from 'lodash/map';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import { withStyles } from '@material-ui/core/styles';

import Share from '../../../components/Share';
import Tag from './components/Tag';
import ReadMore from './components/ReadMore';
import Meta from './components/Meta';
import Comments from './components/Comments';

const styles = theme => ({
  root: {
    borderRadius: 10,
    boxShadow: '-10px 11.1px 50px 0 rgba(188, 198, 210, 0.33)',
    paddingTop: 82,
    paddingRight: 84,
    paddingBottom: 57.4,
    paddingLeft: 47,
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 24,
      paddingRight: 24,
    },
  },
  container: {
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
    },
  },
  content: {
    paddingLeft: 25,
    [theme.breakpoints.down('xs')]: {
      paddingLeft: 0,
    },
  },
  share: { position: 'absolute', right: 40, top: 35 },
  image: {
    [theme.breakpoints.down('xs')]: {
      marginBottom: 12,
      width: '100%',
    },
  },
  date: {
    fontFamily: 'Raleway',
    fontWeight: 500,
    fontSize: 12,
    color: '#b8b8b8',
    lineHeight: 1.25,
  },
  title: {
    fontFamily: 'Paytone One',
    fontSize: 18,
    lineHeight: 1.03,
    color: '#2b2a29',
    marginTop: 5,
  },
  excerpt: {
    marginTop: 10,
    fontFamily: 'Raleway',
    fontSize: 14,
    lineHeight: 1.41,
    color: '#2b2a28',
    '& p': {
      marginBlockStart: 0,
      marginBlockEnd: 0,
    },
  },
  ctaContainer: {
    marginTop: 31.3,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  divider: { height: 1, marginTop: 30 },
  tags: { marginTop: 12.3 },
});

const Post = ({
  classes,
  title,
  slug,
  author,
  excerpt,
  categories,
  tags,
  date,
  featured_media,
  wordpress_id,
}) => {
  const metaProps = {
    author,
    categories,
  };

  const disqusConfig = {
    // String or number that uniquely identifies the post
    identifier: `${wordpress_id}`,
    title,
    url: `${process.env.GATSBY_DISQUS_PROTOCOL}://${process.env.GATSBY_DISQUS_DOMAIN}/blog/${slug}`,
  };

  return (
    <Paper className={classes.root}>
      <Share {...disqusConfig} className={classes.share} />
      <Grid container className={classes.container}>
        <Grid item xs={12} sm={4} className={classes.image}>
          <Img
            fluid={featured_media.localFile.childImageSharp.fluid}
            alt={featured_media.alt_text}
          />
        </Grid>
        <Grid item xs={12} sm={8} className={classes.content}>
          <Grid container>
            <Grid item xs={12} className={classes.date}>
              {date}
            </Grid>
            <Grid
              item
              xs={12}
              className={classes.title}
              dangerouslySetInnerHTML={{ __html: title }}
            />
            <Grid item xs={12} className={classes.meta}>
              <Meta {...metaProps} />
            </Grid>
            <Grid item xs={12} className={classes.excerpt}>
              <div dangerouslySetInnerHTML={{ __html: excerpt }} />
            </Grid>
            <Grid item xs={12} className={classes.ctaContainer}>
              <ReadMore slug={slug} />
              <Comments config={disqusConfig} />
            </Grid>
            <Grid item xs={12}>
              <Divider className={classes.divider} />
            </Grid>
            <Grid item xs={12} className={classes.tags}>
              {map(tags, ({ id, ...tag }) => (
                <Tag key={id} {...tag} />
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default withStyles(styles)(Post);
